import React from 'react';
import { fmtReportDateLabel } from '../../utils/marketingReportDates';

export { fmtReportDateLabel };

export interface MarketingReportDateOption {
  id: string;
  report_date: string;
  headline?: string;
  optionLabel?: string;
}

interface MarketingReportDateBarProps {
  reports: MarketingReportDateOption[];
  selectedId: string | null;
  onSelectId: (id: string | null) => void;
  label?: string;
  todayKey?: string;
  onJumpToToday?: () => void;
  /** When set, jump-to-today selects this id (e.g. combined-all-runs for today). */
  todaySelectId?: string | null;
  /** Compact toolbar variant used by Opportunity Radar. */
  compact?: boolean;
}

const MarketingReportDateBar: React.FC<MarketingReportDateBarProps> = ({
  reports,
  selectedId,
  onSelectId,
  label = 'Report date',
  todayKey,
  onJumpToToday,
  todaySelectId,
  compact = false,
}) => {
  const hasToday = todayKey ? reports.some(r => r.report_date === todayKey) : false;
  const showingToday = todayKey && reports.some(r => r.id === selectedId && r.report_date === todayKey);

  return (
    <div className={compact ? 'mi-date-bar mi-date-bar--toolbar' : 'mi-date-bar'}>
      <label htmlFor="mi-date-select" className="mi-date-label">
        {label}
      </label>
      <select
        id="mi-date-select"
        className="mi-date-select"
        value={selectedId ?? ''}
        onChange={e => onSelectId(e.target.value || null)}
      >
        {reports.map(r => (
          <option key={r.id} value={r.id}>
            {r.optionLabel ??
              `${fmtReportDateLabel(r.report_date)}${todayKey && r.report_date === todayKey ? ' — Today' : ''}${
                r.headline
                  ? ` — ${r.headline.slice(0, 60)}${r.headline.length > 60 ? '…' : ''}`
                  : ''
              }`}
          </option>
        ))}
      </select>
      {hasToday && onJumpToToday && !showingToday && (
        <button type="button" className="mi-date-today-btn" onClick={onJumpToToday}>
          Jump to today
        </button>
      )}
    </div>
  );
};

export default MarketingReportDateBar;
